export default __webpack_public_path__ + "static/media/up.09e23fd8.png";